<template>
  <div class="relative-article">
    <el-row>
      <el-col :span="6">
        <span>班级名称：</span>
        <el-input v-model="name" style="width: 150px" placeholder="请输入班级名称" clearable></el-input>
      </el-col>
      <el-col :span="8" :offset="1">
        <span>班群号：</span>
        <el-input v-model="number" style="width: 150px" placeholder="请输入班群号" clearable></el-input>
      </el-col>
      <el-col :span="6" :offset="3">
        <div class="box box-align-center box-pack-end mt-btns">
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button plain icon="el-icon-refresh" @click="search('refresh')">重置</el-button>
        </div>
      </el-col>
    </el-row>
    <div class="mt12 conmmon-table">
      <dy-table :columns="_columns" :table-data="tableData" ref="table" v-loading="tableLoading" :total="total"
        :page-num="pageNum" :page-size="10" @current-change="onCurrentChange" @selection-change="onSelectionChange"
        element-loading-text="加载中"></dy-table>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px">
        <el-button type="primary" plain @click="saveData">保存</el-button>
        <el-button type="danger" plain @click="closeDialog">取消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import { getClassList } from '@/api/index2';
import { formatDate } from '@/utils/utils';

import { encrypt, decrypt } from '@/api/common_encrypt';

export default {
  name: 'classSelect',
  components: {
    DyTable,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // 使用 computed 计算每行的索引
    indexMethod() {
      return (index) => {
        return (this.pageNum - 1) * this.pageSize + index + 1;
      };
    },
  },
  watch: {
    list(newVal, oldVal) {
      this.setSelect();
    },
  },
  data() {
    return {
      name: '',
      number: '',

      tableLoading: true,
      pageNum: 1,
      pageSize: 10,
      options: [],
      _columns: [],
      tableData: [],
      total: 0,

      chooseVisible: false,
      arTableLoading: true,
      arTotal: 0,

      selectId: [],
      selection: [],
      isCurrentChange: false,

      searchForm: {},
    };
  },
  created() {
    this._columns = [
      {
        type: 'selection',
        width: '55',
      },
      ...this.columns,
      {
        key: 'maxSize',
        title: '班级预设人数上限',
      },
      {
        key: 'createTime',
        title: '最后更新时间',
      },
    ];
  },
  mounted() {
    this.selectId = this.list.map((e) => {
      return e.recommendId;
    });

    this.selection = this.list;

    this.getList();
  },
  methods: {
    // 关闭弹窗
    closeDialog() {
      this.$emit('close-dialog');
    },
    onSelectionChange(val) {
      console.log('val11', val);
      if (this.isCurrentChange) {
        this.isCurrentChange = false;
        return;
      }
      let pageId = this.tableData.map((e) => {
        return e.recommendId;
      });
      let selId = val.map((e) => {
        return e.recommendId;
      });
      let delId = pageId.filter((recommendId) => !selId.includes(recommendId));
      this.selectId = [...new Set([...this.selectId, ...pageId].filter((id) => !delId.includes(id)))];
      // 合并数组
      this.selection = [...this.selection, ...val];
      // 根据 ID 去重
      this.selection = Array.from(new Map(this.selection.map((item) => [item.recommendId, item])).values());
      this.selection = this.selection.filter((e) => !delId.includes(e.recommendId));
    },
    saveData() {
      this.$emit('saveData', this.selection);
      this.$emit('close-dialog');
    },
    onCurrentChange(val) {
      console.log('val22', val);
      if (this.isSetSelect) {
        this.isCurrentChange = true;
      }
      this.pageNum = val;
      this.getList();
    },

    search(msg) {
      this.pageNum = 1;
      this.searchForm = {
        className: this.name,
        classNumber: this.number,
      };
      if (msg == 'refresh') {
        this.name = '';
        this.number = '';
        this.searchForm = {};
      }

      this.getList();
    },

    getList() {
      this.tableLoading = true;

      let param = {
        needPage: true,
        page: this.pageNum,
        pageSize: this.pageSize,
        ...this.searchForm,

      };

      getClassList(param).then((res) => {
        if (res.result == 1) {
          this.tableLoading = false;
          this.total = res.data.total;
          console.log('112233', res);


          this.tableData = res.data.list.map((item) => {
            return {
              ...item,
              updateTime: formatDate(new Date(item.updateTime), 'yyyy-MM-dd hh:mm:ss'),
            };
          });
          console.log('this.tableData :>> ', this.tableData);

          for (let e of this.tableData) {
            e.recommendId = e.classId;
            e.recommendType = 4;
          }

          this.setSelect();

        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
        this.tableLoading = false;
      });

    },

    setSelect() {
      this.$refs.table.$refs.ElTable.clearSelection();
      let sel = this.tableData.filter((item) => this.selectId.includes(item.recommendId));
      this.$nextTick(() => {
        sel.forEach((e) => {
          this.$refs.table.$refs.ElTable.toggleRowSelection(e, true);
        });
      });
    },
  },
};
</script>
<style scoped>
.ra-table {
  margin-top: 12px;
  margin-bottom: 22px;
}
</style>
